import { r as registerInstance, h, H as Host } from './index-2b2e631a.js';
import { g as getFieldValue } from './utils-9a999346.js';
import './state-3cc1e9a3.js';

let SearchTopHitPerson = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  /**
   * Render element
   */
  render() {
    // Create constant for storing avatar alternative text
    const avatarAltText = `${getFieldValue(this.topHit.Fields, 'Title')} profile photo`;
    // Create constant for storing role
    const role = getFieldValue(this.topHit.Fields, 'Role', '');
    // Return element
    return (h(Host, { class: "TopHit__Inner" }, h("div", { class: "TopHit__Avatar", style: { backgroundImage: 'url(https://via.placeholder.com/65)' }, role: "img", "aria-label": avatarAltText }), h("div", { class: "TopHit__Main" }, h("slot", null), role && (h("p", null, role)))));
  }
};

export { SearchTopHitPerson as search_top_hit_person };
